module.exports = __webpack_public_path__ + "img/3000f.82e997ae.png";